// extracted by mini-css-extract-plugin
export default {"container":"container___HsaVj","fileImg":"fileImg___K2hBG","actions":"actions___BaW9q","fileName":"fileName___Gd7Ui","popover":"popover___IKAfT"};